/* eslint typescript-sort-keys/string-enum: "warn", curly: "error" */

export enum ApplicationEvents {
  /** @deprecated In favor of promise api in authentication object (onReady, onUserAvailable) */
  UserAvailable = "UserAvailable",
}
